import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const SearchBar = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}: SearchBarProps) => (
  <div className={`relative max-w-md flex-1 ${className}`} role="search">
    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
      <MagnifyingGlassIcon
        className="h-5 w-5 text-gray-400"
        aria-hidden="true"
      />
    </div>
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={placeholder}
      className="w-full rounded-lg border border-gray-200 bg-white py-2.5 pr-4 pl-10 text-sm placeholder:text-gray-400 focus:border-[#0072ce] focus:ring-2 focus:ring-[#0072ce]/20 focus:outline-none"
    />
  </div>
);

export default SearchBar;
